import React, { useState } from "react";
import { Card, Row, Col, Dropdown, DropdownButton } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import { useAppContext } from "../../services/context";

const BarGraph = () => {
  const { state } = useAppContext();
  const { dashboardData } = state;
  const [barFilter, setBarFilter] = useState("day");

  const barGraph = {
    labels:
      barFilter === "day"
        ? dashboardData?.users_vs_games?.daily?.map((m) => m.date) || [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
          ]
        : barFilter === "week"
          ? ["Week 1", "Week 2", "Week 3", "Week 4"]
          : dashboardData?.users_vs_games?.monthly?.map((m) => m.month) || [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ],
    datasets: [
      {
        label: "Games",
        data:
          barFilter === "day"
            ? dashboardData?.users_vs_games?.daily?.map((m) => m.games) || []
            : barFilter === "week"
              ? dashboardData?.users_vs_games?.weekly?.map((m) => m.games) || []
              : dashboardData?.users_vs_games?.monthly?.map((m) => m.games) ||
                [],
        borderColor: "#28a745",
        backgroundColor: "rgba(40, 167, 69, 0.2)",
        fill: true,
      },
      {
        label: "Users",
        data:
          barFilter === "day"
            ? dashboardData?.users_vs_games?.daily?.map((m) => m?.users) || []
            : barFilter === "week"
              ? dashboardData?.users_vs_games?.weekly?.map((m) => m?.users) ||
                []
              : dashboardData?.users_vs_games?.monthly?.map((m) => m?.users) ||
                [],
        borderColor: "#17a2b8",
        backgroundColor: "rgba(23, 162, 184, 0.2)",
        fill: true,
      },
    ],
  };
  return (
    <div>
      <Row className="mb-4">
        <Col>
          <DropdownButton
            id="dropdown-basic-button"
            className="btn-success text-white"
            title={`Filter by ${barFilter}`}
            onSelect={(e) => setBarFilter(e)}
            style={{
              borderRadius: "30px",
              padding: "10px 20px",
              fontSize: "1.1rem",
            }}
          >
            <Dropdown.Item eventKey="day">Day</Dropdown.Item>
            <Dropdown.Item eventKey="week">Week</Dropdown.Item>
            <Dropdown.Item eventKey="month">Month</Dropdown.Item>
          </DropdownButton>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card
            className="bg-dark text-white mb-4"
            style={{ borderRadius: "15px" }}
          >
            <Card.Body>
              <Card.Title>Total Played Games ({barFilter})</Card.Title>
              <Bar data={barGraph} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default BarGraph;
